import React from 'react';
import type { AppointmentType } from '@/modules/appointment/api/appointmentType.api';
import AppointmentTypeFormDialog from './AppointmentTypeFormDialog';

export type QuickCreateAppointmentTypeDialogProps = {
  open: boolean;
  onClose: () => void;
  onCreated: (type: AppointmentType) => void;
};

const QuickCreateAppointmentTypeDialog: React.FC<QuickCreateAppointmentTypeDialogProps> = ({
  open,
  onClose,
  onCreated,
}) => (
  <AppointmentTypeFormDialog
    open={open}
    onClose={onClose}
    mode="quick"
    onCreated={onCreated}
  />
);

export default QuickCreateAppointmentTypeDialog;
